var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _g, _g2, _g3, _g4, _g5, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommonBeats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 634,
    height: 634,
    viewBox: "0 0 634 634",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M193.464 271.864C195.369 266.417 199.592 259.361 203.815 253.717",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M207.577 248.071C215.553 237.252 227.753 225.963 238.004 220.59",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M264.902 218.823C248.588 224.569 225.408 238.663 216.024 254.186",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M201.848 276.283C204.657 270.652 208.983 263.124 212.268 259.361",
    stroke: "#FF9F19",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M198.761 282.913C196.116 290.427 194.352 301.477 193.029 308.549",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M199.598 331.332C201.656 320.134 206.609 297.943 209.783 290.871",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M211.99 284.24C214.417 278.505 217.9 269.71 221.653 265.006",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M225.872 258.89C237.603 241.485 261.064 229.256 275.919 225.895",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M208.512 343.558C210.423 336.044 212.61 334.585 213.75 319.157C214.632 307.223 223.527 280.057 231.504 271.59",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M236.664 264.063C247.925 246.659 276.548 234.429 291.792 232.524",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M216.949 353.909C223.122 337.554 222.56 326.232 226.529 311.646",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M228.304 305.013C230.764 297.617 234.793 284.292 241.831 277.706",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M245.585 271.593C260.601 251.837 287.346 242.899 301.057 241.81",
    stroke: "#DE3835",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M226.347 361.905C228.699 353.801 232.274 345.677 234.478 333.301",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M235.364 325.346C235.364 316.063 239.67 298.436 249.811 284.292",
    stroke: "#FF9F19",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M253.437 278.938C266.665 261.7 288.27 252.859 308.111 251.975",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M318.688 251.532C335.671 250.422 366.171 265.004 374.148 279.587",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M377.908 284.76C381.193 288.994 384.947 296.52 387.917 306.781",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M390.118 314.297C391.147 318.864 391.98 344.501 385.88 366.138",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M384.936 372.724C383.172 381.564 382.617 381.482 380.412 389.88",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M234.794 369.432C237.587 361.034 242.328 348.156 243.739 340.376",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M245.935 331.533C247.699 316.505 248.575 305.049 258.716 291.347",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M262.479 285.704C269.974 277.748 289.617 263.126 310.34 263.126",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M316.897 263.126C331.447 263.126 350.681 269.241 362.881 285.704",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M367.117 290.406C372.748 297.933 377.44 306.87 379.1 318.275",
    stroke: "#DE3835",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M379.313 325.685C380.195 331.431 380.721 343.089 376.498 360.493",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M374.614 366.61C371.968 376.923 368.51 391.648 364.542 403.582",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M242.861 382.367C244.031 379.005 247.221 371.731 248.405 368.02M268.113 297.933C255.913 312.985 261.074 331.8 250.282 361.435",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M310.334 273.475C296.156 273.475 281.729 280.692 272.796 291.009",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M365.237 360.493C361.268 383.035 349.557 413.747 346.911 422.587",
    stroke: "#FF9F19",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M312.683 328.51C310.919 344.864 306.787 370.876 297.969 396.513",
    stroke: "#DE3835",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M295.326 403.581C291.799 411.979 285.449 427.45 284.744 429.218",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M276.551 418.822C289.689 393.891 297.666 356.731 300.613 342.585",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M301.494 334.629C302.197 324.292 306.583 317.69 314.559 317.689C322.536 317.689 326.186 324.906 323.54 337.281",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M323.006 344.971C321.915 352.174 317.375 368.49 314.56 379.779",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M309.869 395.302C304.238 413.177 300.015 424.466 292.977 439.518",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M302.366 446.575C306.12 438.108 307.058 435.756 310.812 424.937",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M315.028 414.588C319.143 402.654 332.858 350.616 334.266 340.738",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M316.429 306.871C319.739 307.022 322.745 308.339 325.345 310.336",
    stroke: "#FF9F19",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M299.07 310.541C301.453 308.234 305.639 306.399 310.331 306.399",
    stroke: "#FF9F19",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M289.221 336.033C290.213 327.084 292.981 318.896 294.852 315.807",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M288.746 343.559C286.4 362.374 277.68 390.319 268.421 411.094",
    stroke: "#FF9F19",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M260.125 403.298C268.594 384.057 273.264 364.727 276.548 350.145",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M333.791 303.578C329.568 299.814 324.406 296.522 316.429 296.051",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M310.338 296.051C304.708 296.051 297.2 298.403 290.631 304.988",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M286.88 310.161C279.372 321.921 278.434 333.681 277.026 342.618",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M310.334 285.23C300.48 285.23 289.688 288.523 281.242 298.769",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M335.333 334.245C336.064 328.628 335.332 319.1 330.046 314.397",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M338.021 308.281C342.713 312.985 348.344 327.096 345.06 341.678",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M343.178 348.264C339.893 371.783 322.435 429.178 313.617 451.278",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M251.679 392.951C256.822 380.67 259.187 373.665 263.41 358.613",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M264.809 352.027C265.747 342.149 270.658 319.083 278.416 304.518",
    stroke: "#FF9F19",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M316.429 285.232C329.098 286.173 337.545 289.936 344.583 297.462",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M348.813 302.636C355.427 311.476 358.667 335.092 355.852 347.792",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M353.974 354.379C352.097 366.138 349.997 373.968 344.265 393.416",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M342.062 400.045C336.615 419.292 333.844 426.571 327.23 444.693",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M323.545 240.923C336.332 240.923 366.646 249.013 382.13 271.121",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M397.179 370.873C400.265 356.287 401.147 348.331 402.47 336.396",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M402.909 328.883C402.909 313.926 395.268 287.584 387.291 278.177",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M333.687 231.643C346.473 232.969 370.283 239.157 391.447 264.793",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M396.203 271.122C401.365 278.177 414.972 303.578 412.626 339.327",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M343.822 222.359C356.167 225.011 388.695 239.605 401.364 258.891",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M406.52 265.476C412.151 273.942 417.312 286.643 419.213 294.848",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M420.981 301.921C423.627 312.971 424.068 321.811 423.186 338.165",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M360.572 217.497C372.918 220.591 400.419 236.313 410.742 254.658",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M415.443 261.242C422.95 273.472 432.89 298.384 432.89 314.738",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M389.232 221.475C396.58 225.453 409.804 233.96 418.25 248.542",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M422.011 254.187C425.295 258.891 431.565 271.865 434.211 279.821",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M316.429 273.475C330.568 273.475 345.521 280.06 353.498 291.35",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M357.26 296.521C368.522 312.514 370.399 337.445 366.645 353.908",
    stroke: "#00AB5B",
    strokeWidth: 3.73138,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_475_15274)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-71-inside-1_475_15274",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.733 99.4975C317.722 94.4071 313.584 90.2696 308.499 90.4875C266.583 92.2831 225.923 105.701 191.107 129.327C156.29 152.953 128.801 185.78 111.648 224.068C109.567 228.714 111.884 234.087 116.61 235.978L144.47 247.12C149.196 249.01 154.538 246.699 156.67 242.077C170.2 212.753 191.487 187.608 218.306 169.409C245.124 151.21 276.354 140.717 308.602 138.977C313.685 138.703 317.806 134.593 317.795 129.503L317.733 99.4975Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M317.733 99.4975C317.722 94.4071 313.584 90.2696 308.499 90.4875C266.583 92.2831 225.923 105.701 191.107 129.327C156.29 152.953 128.801 185.78 111.648 224.068C109.567 228.714 111.884 234.087 116.61 235.978L144.47 247.12C149.196 249.01 154.538 246.699 156.67 242.077C170.2 212.753 191.487 187.608 218.306 169.409C245.124 151.21 276.354 140.717 308.602 138.977C313.685 138.703 317.806 134.593 317.795 129.503L317.733 99.4975Z",
    fill: "#00AB5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.733 99.4975C317.722 94.4071 313.584 90.2696 308.499 90.4875C266.583 92.2831 225.923 105.701 191.107 129.327C156.29 152.953 128.801 185.78 111.648 224.068C109.567 228.714 111.884 234.087 116.61 235.978L144.47 247.12C149.196 249.01 154.538 246.699 156.67 242.077C170.2 212.753 191.487 187.608 218.306 169.409C245.124 151.21 276.354 140.717 308.602 138.977C313.685 138.703 317.806 134.593 317.795 129.503L317.733 99.4975Z",
    stroke: "#055E34",
    strokeOpacity: 0.4,
    strokeWidth: 2.30423,
    mask: "url(#path-71-inside-1_475_15274)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_475_15274)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-72-inside-2_475_15274",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.472 249.054C105.635 247.47 100.41 250.104 99.0241 255.002C87.5415 295.596 87.6182 338.658 99.3412 379.31C111.064 419.962 133.929 456.453 165.263 484.7C169.044 488.108 174.869 487.555 178.12 483.639L198.474 459.122C201.726 455.206 201.168 449.412 197.427 445.96C173.834 424.189 156.598 396.333 147.67 365.373C138.742 334.414 138.499 301.658 146.877 270.667C148.206 265.753 145.593 260.552 140.755 258.968L110.472 249.054Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M110.472 249.054C105.635 247.47 100.41 250.104 99.0241 255.002C87.5415 295.596 87.6182 338.658 99.3412 379.31C111.064 419.962 133.929 456.453 165.263 484.7C169.044 488.108 174.869 487.555 178.12 483.639L198.474 459.122C201.726 455.206 201.168 449.412 197.427 445.96C173.834 424.189 156.598 396.333 147.67 365.373C138.742 334.414 138.499 301.658 146.877 270.667C148.206 265.753 145.593 260.552 140.755 258.968L110.472 249.054Z",
    fill: "#FF9F19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.472 249.054C105.635 247.47 100.41 250.104 99.0241 255.002C87.5415 295.596 87.6182 338.658 99.3412 379.31C111.064 419.962 133.929 456.453 165.263 484.7C169.044 488.108 174.869 487.555 178.12 483.639L198.474 459.122C201.726 455.206 201.168 449.412 197.427 445.96C173.834 424.189 156.598 396.333 147.67 365.373C138.742 334.414 138.499 301.658 146.877 270.667C148.206 265.753 145.593 260.552 140.755 258.968L110.472 249.054Z",
    stroke: "#DB8307",
    strokeWidth: 2.30423,
    mask: "url(#path-72-inside-2_475_15274)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_475_15274)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-73-inside-3_475_15274",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.066 490.974C185.033 495.062 185.88 500.852 190.088 503.716C224.46 527.103 264.667 540.605 306.31 542.647C347.952 544.69 389.288 535.189 425.784 515.279C430.253 512.841 431.662 507.162 429.044 502.796L412.858 475.802C410.24 471.436 404.589 470.042 400.093 472.428C372.087 487.291 340.536 494.358 308.755 492.799C276.975 491.239 246.267 481.118 219.85 463.586C215.609 460.771 209.849 461.605 206.816 465.693L188.066 490.974Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M188.066 490.974C185.033 495.062 185.88 500.852 190.088 503.716C224.46 527.103 264.667 540.605 306.31 542.647C347.952 544.69 389.288 535.189 425.784 515.279C430.253 512.841 431.662 507.162 429.044 502.796L412.858 475.802C410.24 471.436 404.589 470.042 400.093 472.428C372.087 487.291 340.536 494.358 308.755 492.799C276.975 491.239 246.267 481.118 219.85 463.586C215.609 460.771 209.849 461.605 206.816 465.693L188.066 490.974Z",
    fill: "#6EABEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.066 490.974C185.033 495.062 185.88 500.852 190.088 503.716C224.46 527.103 264.667 540.605 306.31 542.647C347.952 544.69 389.288 535.189 425.784 515.279C430.253 512.841 431.662 507.162 429.044 502.796L412.858 475.802C410.24 471.436 404.589 470.042 400.093 472.428C372.087 487.291 340.536 494.358 308.755 492.799C276.975 491.239 246.267 481.118 219.85 463.586C215.609 460.771 209.849 461.605 206.816 465.693L188.066 490.974Z",
    stroke: "#368BE9",
    strokeOpacity: 0.5,
    strokeWidth: 2.30423,
    mask: "url(#path-73-inside-3_475_15274)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_475_15274)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-74-inside-4_475_15274",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M441.107 495.053C444.006 499.238 449.761 500.294 453.824 497.227C487.309 471.949 513.16 437.817 528.405 398.601C543.651 359.384 547.64 316.754 540.02 275.497C539.095 270.491 534.138 267.383 529.174 268.511L497.707 275.658C492.743 276.786 489.658 281.721 490.524 286.738C495.939 318.117 492.728 350.443 481.148 380.23C469.569 410.017 450.104 436.024 424.916 455.508C420.89 458.622 419.831 464.345 422.73 468.529L441.107 495.053Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M441.107 495.053C444.006 499.238 449.761 500.294 453.824 497.227C487.309 471.949 513.16 437.817 528.405 398.601C543.651 359.384 547.64 316.754 540.02 275.497C539.095 270.491 534.138 267.383 529.174 268.511L497.707 275.658C492.743 276.786 489.658 281.721 490.524 286.738C495.939 318.117 492.728 350.443 481.148 380.23C469.569 410.017 450.104 436.024 424.916 455.508C420.89 458.622 419.831 464.345 422.73 468.529L441.107 495.053Z",
    fill: "#00AB5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.107 495.053C444.006 499.238 449.761 500.294 453.824 497.227C487.309 471.949 513.16 437.817 528.405 398.601C543.651 359.384 547.64 316.754 540.02 275.497C539.095 270.491 534.138 267.383 529.174 268.511L497.707 275.658C492.743 276.786 489.658 281.721 490.524 286.738C495.939 318.117 492.728 350.443 481.148 380.23C469.569 410.017 450.104 436.024 424.916 455.508C420.89 458.622 419.831 464.345 422.73 468.529L441.107 495.053Z",
    stroke: "#055E34",
    strokeOpacity: 0.4,
    strokeWidth: 2.30423,
    mask: "url(#path-74-inside-4_475_15274)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_475_15274)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-75-inside-5_475_15274",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M525.538 252.537C530.402 251.034 533.145 245.866 531.446 241.068C517.112 200.578 491.523 164.937 457.6 138.385C423.678 111.832 382.935 95.5522 340.187 91.3615C335.121 90.8648 330.763 94.769 330.473 99.8511L328.675 131.364C328.385 136.446 332.274 140.776 337.334 141.331C369.898 144.904 400.891 157.489 426.783 177.756C452.675 198.023 472.335 225.085 483.624 255.839C485.379 260.617 490.516 263.353 495.38 261.851L525.538 252.537Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M525.538 252.537C530.402 251.034 533.145 245.866 531.446 241.068C517.112 200.578 491.523 164.937 457.6 138.385C423.678 111.832 382.935 95.5522 340.187 91.3615C335.121 90.8648 330.763 94.769 330.473 99.8511L328.675 131.364C328.385 136.446 332.274 140.776 337.334 141.331C369.898 144.904 400.891 157.489 426.783 177.756C452.675 198.023 472.335 225.085 483.624 255.839C485.379 260.617 490.516 263.353 495.38 261.851L525.538 252.537Z",
    fill: "#FF9F19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.538 252.537C530.402 251.034 533.145 245.866 531.446 241.068C517.112 200.578 491.523 164.937 457.6 138.385C423.678 111.832 382.935 95.5522 340.187 91.3615C335.121 90.8648 330.763 94.769 330.473 99.8511L328.675 131.364C328.385 136.446 332.274 140.776 337.334 141.331C369.898 144.904 400.891 157.489 426.783 177.756C452.675 198.023 472.335 225.085 483.624 255.839C485.379 260.617 490.516 263.353 495.38 261.851L525.538 252.537Z",
    stroke: "#DB8307",
    strokeWidth: 2.30423,
    mask: "url(#path-75-inside-5_475_15274)"
  }))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M369.215 128.404C367.884 128.035 366.684 127.484 365.616 126.749L366.575 124.317C367.552 125.172 368.59 125.752 369.69 126.057C370.464 126.272 371.132 126.289 371.694 126.108C372.255 125.927 372.613 125.559 372.768 125.002C372.869 124.635 372.874 124.3 372.783 123.997C372.695 123.681 372.487 123.352 372.157 123.012C371.84 122.676 371.353 122.27 370.695 121.796C369.926 121.246 369.328 120.715 368.9 120.201C368.489 119.678 368.223 119.136 368.1 118.576C367.991 118.019 368.031 117.402 368.219 116.723C368.448 115.894 368.86 115.226 369.454 114.718C370.062 114.214 370.791 113.904 371.642 113.789C372.51 113.664 373.447 113.741 374.451 114.019C375.09 114.196 375.669 114.401 376.19 114.633C376.724 114.868 377.245 115.152 377.753 115.482L376.885 117.743C376.402 117.375 375.936 117.077 375.487 116.851C375.052 116.628 374.61 116.454 374.162 116.33C373.415 116.123 372.776 116.107 372.245 116.281C371.718 116.442 371.387 116.767 371.251 117.256C371.165 117.568 371.158 117.859 371.229 118.127C371.319 118.386 371.514 118.681 371.817 119.014C372.124 119.333 372.589 119.71 373.214 120.147C374.024 120.707 374.646 121.26 375.08 121.804C375.527 122.352 375.809 122.92 375.924 123.508C376.039 124.095 375.998 124.742 375.803 125.448C375.554 126.344 375.119 127.072 374.496 127.63C373.877 128.175 373.109 128.518 372.193 128.659C371.294 128.79 370.301 128.705 369.215 128.404Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M392.069 122.724L388.294 121.294L389.214 118.975L399.606 123.102L398.686 125.42L394.879 123.84L390.331 135.293L387.522 134.178L392.069 122.724Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M413.903 130.042L416.868 131.625L415.102 147.407L412.249 145.884L412.715 142.275L407.289 139.378L404.549 141.772L401.845 140.329L413.903 130.042ZM413.061 139.92L413.603 136.304C413.672 135.845 413.772 135.284 413.903 134.619C414.041 133.942 414.167 133.362 414.281 132.88L414.244 132.86C413.894 133.216 413.486 133.621 413.02 134.075C412.56 134.517 412.127 134.924 411.72 135.298L409.015 137.76L413.061 139.92Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M430.571 139.845L434.284 142.428C435.707 143.418 436.639 144.435 437.079 145.48C437.52 146.525 437.366 147.585 436.617 148.661C436.126 149.366 435.498 149.813 434.732 150.001C433.966 150.189 433.112 150.084 432.17 149.687L432.146 149.721C432.956 150.457 433.433 151.252 433.576 152.107C433.728 152.95 433.526 153.771 432.97 154.569C432.415 155.367 431.745 155.862 430.959 156.054C430.181 156.234 429.358 156.184 428.488 155.905C427.637 155.622 426.778 155.179 425.91 154.576L422.145 151.956L430.571 139.845ZM430.024 147.035C430.637 147.461 431.178 147.769 431.647 147.958C432.117 148.147 432.546 148.197 432.934 148.107C433.335 148.025 433.688 147.764 433.994 147.325C434.42 146.711 434.482 146.128 434.181 145.575C433.899 145.018 433.358 144.462 432.56 143.907L431.675 143.291L429.382 146.588L430.024 147.035ZM426.571 152.331C427.577 153.031 428.408 153.404 429.064 153.448C429.731 153.5 430.282 153.214 430.717 152.589C431.143 151.976 431.206 151.368 430.906 150.764C430.605 150.16 429.928 149.492 428.876 148.759L428.199 148.288L425.773 151.776L426.571 152.331Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M449.273 153.892L451.542 155.824L441.974 167.055L439.705 165.122L449.273 153.892Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M460.904 164.446L462.983 166.581L454.231 175.105L458.228 179.209L456.411 180.979L450.335 174.74L460.904 164.446Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M475.318 180.339L477.19 182.658L465.711 191.927L463.839 189.608L475.318 180.339Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M484.238 196.411L481.951 193.083L484.029 191.703L490.215 201.017L488.138 202.397L485.91 198.928L475.645 205.747L473.973 203.229L484.238 196.411Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M489.964 218.648L495.331 209.719L496.938 212.814L495.062 215.669C494.784 216.083 494.411 216.618 493.942 217.274C493.479 217.943 493.088 218.504 492.767 218.956L492.786 218.993C493.624 218.987 494.964 218.998 496.805 219.027L500.2 219.099L501.689 221.97L491.318 221.303L486.121 224L484.748 221.355L489.964 218.648Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M155.047 439.949L151.964 436.639C150.783 435.37 150.087 434.179 149.878 433.065C149.668 431.951 150.043 430.947 151.001 430.054C151.63 429.468 152.339 429.164 153.128 429.142C153.916 429.121 154.728 429.404 155.565 429.992L155.596 429.963C154.96 429.073 154.662 428.195 154.702 427.329C154.733 426.472 155.104 425.713 155.815 425.05C156.527 424.388 157.287 424.046 158.095 424.024C158.893 424.013 159.688 424.235 160.479 424.692C161.251 425.148 161.996 425.763 162.717 426.536L165.843 429.893L155.047 439.949ZM157.102 433.037C156.593 432.491 156.129 432.075 155.711 431.791C155.292 431.507 154.883 431.368 154.484 431.374C154.075 431.37 153.675 431.55 153.283 431.915C152.737 432.424 152.553 432.981 152.731 433.585C152.889 434.189 153.299 434.847 153.962 435.558L154.697 436.347L157.635 433.61L157.102 433.037ZM161.597 428.59C160.761 427.693 160.028 427.154 159.396 426.972C158.755 426.78 158.156 426.943 157.599 427.462C157.053 427.971 156.862 428.552 157.029 429.206C157.195 429.86 157.715 430.656 158.589 431.594L159.151 432.198L162.26 429.302L161.597 428.59Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M137.392 418.579L135.495 415.805L144.355 402.625L146.18 405.294L144.1 408.28L147.572 413.357L151.109 412.499L152.839 415.029L137.392 418.579ZM142.704 410.208L140.552 413.165C140.279 413.539 139.931 413.991 139.507 414.52C139.072 415.057 138.692 415.513 138.369 415.888L138.393 415.923C138.868 415.768 139.417 415.598 140.04 415.411C140.651 415.231 141.224 415.07 141.758 414.927L145.293 413.994L142.704 410.208Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M127.31 401.974L125.997 399.298L136.965 393.916L134.442 388.774L136.719 387.656L140.555 395.474L127.31 401.974Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M117.328 378.204L116.295 375.006L128.528 364.879L129.522 367.956L126.68 370.229L128.571 376.082L132.206 376.263L133.148 379.18L117.328 378.204ZM124.795 371.682L121.894 373.908C121.526 374.19 121.063 374.524 120.507 374.911C119.938 375.302 119.444 375.632 119.027 375.9L119.04 375.94C119.54 375.927 120.115 375.919 120.765 375.916C121.403 375.918 121.997 375.925 122.55 375.939L126.205 376.047L124.795 371.682Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M112.334 359.401L111.692 355.479L118.286 350.629C118.732 350.299 119.354 349.868 120.152 349.338C120.934 348.795 121.623 348.333 122.217 347.95L122.21 347.908C121.686 348.022 120.884 348.182 119.804 348.388C118.724 348.594 117.753 348.767 116.89 348.908L110.779 349.91L110.345 347.261L124.904 344.875L125.513 348.588L118.991 353.49C118.366 353.95 117.643 354.461 116.822 355.024C116 355.587 115.343 356.023 114.851 356.332L114.858 356.374C115.271 356.278 115.984 356.139 116.996 355.959C118.007 355.765 118.895 355.605 119.66 355.48L126.459 354.366L126.894 357.015L112.334 359.401Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M124.347 328.559C124.367 330.151 124.089 331.557 123.512 332.776C122.921 333.981 122.066 334.929 120.947 335.619C119.814 336.296 118.473 336.644 116.923 336.663C115.429 336.682 114.108 336.36 112.958 335.698C111.808 335.035 110.916 334.116 110.281 332.941C109.646 331.751 109.32 330.416 109.301 328.936C109.293 328.246 109.327 327.626 109.405 327.075C109.468 326.51 109.595 325.938 109.785 325.358L112.345 325.538C112.112 326.062 111.95 326.571 111.857 327.066C111.75 327.56 111.701 328.096 111.708 328.674C111.72 329.66 111.928 330.517 112.332 331.245C112.721 331.973 113.299 332.537 114.065 332.936C114.817 333.321 115.728 333.507 116.799 333.494C117.856 333.481 118.769 333.258 119.539 332.825C120.308 332.379 120.893 331.78 121.292 331.028C121.691 330.276 121.885 329.435 121.873 328.505C121.866 327.928 121.817 327.379 121.726 326.858C121.635 326.338 121.481 325.804 121.262 325.258L123.818 325.12C123.979 325.583 124.106 326.117 124.198 326.722C124.29 327.313 124.339 327.925 124.347 328.559Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M110.29 312.418L111.433 303.764L113.864 304.085L113.105 309.826L116.626 310.291L117.323 305.011L119.691 305.324L118.994 310.604L122.849 311.113L123.616 305.309L126.068 305.633L124.917 314.35L110.29 312.418Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M528.084 293.638L528.097 302.367L525.645 302.371L525.636 296.58L522.085 296.585L522.093 301.912L519.705 301.915L519.697 296.589L515.808 296.595L515.817 302.45L513.344 302.454L513.33 293.661L528.084 293.638Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M527.614 312.614L527.272 316.573L519.687 319.652C519.174 319.863 518.465 320.127 517.56 320.445C516.669 320.778 515.888 321.057 515.218 321.282L515.214 321.324C515.75 321.342 516.567 321.384 517.664 321.451C518.762 321.517 519.746 321.588 520.616 321.663L526.786 322.196L526.555 324.871L511.857 323.601L512.18 319.853L519.708 316.705C520.426 316.414 521.253 316.096 522.188 315.752C523.122 315.409 523.866 315.148 524.419 314.969L524.423 314.927C523.999 314.919 523.274 314.877 522.248 314.803C521.221 314.743 520.321 314.679 519.549 314.612L512.684 314.019L512.915 311.345L527.614 312.614Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M525.278 333.179L524.565 337.153C524.092 339.788 523.134 341.771 521.693 343.101C520.251 344.431 518.254 344.867 515.702 344.409C514.066 344.115 512.774 343.496 511.827 342.553C510.891 341.626 510.282 340.472 510 339.09C509.73 337.724 509.745 336.209 510.043 334.545L510.757 330.571L525.278 333.179ZM512.318 334.674C512.002 336.436 512.144 337.914 512.745 339.11C513.347 340.307 514.521 341.061 516.269 341.375C518.099 341.704 519.483 341.416 520.419 340.51C521.368 339.607 522.004 338.26 522.325 336.471L522.463 335.702L512.456 333.905L512.318 334.674Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M505.041 355.096C505.592 353.099 506.477 351.772 507.696 351.115C508.926 350.474 510.532 350.428 512.515 350.975L521.093 353.342L520.295 356.235L511.92 353.924C510.603 353.561 509.575 353.526 508.836 353.819C508.107 354.129 507.608 354.774 507.338 355.752C507.046 356.811 507.131 357.668 507.594 358.322C508.07 358.98 508.967 359.49 510.284 359.854L518.659 362.164L517.9 364.915L509.322 362.548C507.379 362.012 506.049 361.112 505.331 359.847C504.609 358.595 504.513 357.011 505.041 355.096Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M515.021 373.237L513.514 377.232C513.056 378.445 512.568 379.42 512.048 380.158C511.524 380.909 510.907 381.407 510.198 381.651C509.496 381.914 508.684 381.871 507.761 381.523C506.864 381.184 506.234 380.66 505.869 379.951C505.518 379.246 505.424 378.397 505.587 377.404L505.548 377.389C505.349 377.676 505.133 377.888 504.901 378.026C504.663 378.178 504.404 378.284 504.126 378.344C503.847 378.404 503.486 378.442 503.044 378.456L497.196 378.689L498.352 375.624L502.85 375.558C503.47 375.551 503.931 375.507 504.233 375.425C504.53 375.356 504.779 375.194 504.981 374.939C505.196 374.689 505.41 374.28 505.624 373.713L505.9 372.982L500.165 370.818L501.217 368.03L515.021 373.237ZM507.73 374.598C507.312 375.706 507.16 376.567 507.275 377.183C507.384 377.811 507.781 378.255 508.467 378.513C508.955 378.697 509.378 378.714 509.736 378.563C510.089 378.425 510.399 378.143 510.665 377.716C510.94 377.308 511.214 376.741 511.488 376.016L511.793 375.205L508.036 373.787L507.73 374.598Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M505.377 396.123L503.908 399.146L488.07 397.984L489.483 395.075L493.107 395.403L495.795 389.87L493.298 387.223L494.637 384.466L505.377 396.123ZM495.474 395.659L499.108 396.062C499.569 396.114 500.134 396.192 500.803 396.298C501.485 396.41 502.069 396.514 502.556 396.609L502.574 396.571C502.205 396.235 501.784 395.843 501.313 395.394C500.854 394.952 500.43 394.535 500.041 394.142L497.478 391.534L495.474 395.659Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M497.642 410.76L495.586 414.16L487.42 413.571C486.867 413.533 486.115 413.457 485.163 413.342C484.216 413.247 483.392 413.153 482.692 413.058L482.67 413.095C483.143 413.348 483.857 413.746 484.812 414.291C485.767 414.835 486.618 415.334 487.366 415.786L492.666 418.99L491.277 421.287L478.651 413.654L480.598 410.434L488.742 410.936C489.515 410.992 490.397 411.072 491.387 411.177C492.377 411.282 493.16 411.377 493.735 411.461L493.757 411.425C493.381 411.23 492.749 410.873 491.861 410.352C490.966 409.844 490.187 409.39 489.524 408.989L483.627 405.424L485.016 403.127L497.642 410.76Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M470.172 425.153C471.117 423.872 472.187 422.919 473.383 422.295C474.581 421.69 475.835 421.45 477.144 421.575C478.455 421.719 479.735 422.251 480.983 423.171C482.185 424.057 483.045 425.111 483.562 426.333C484.079 427.555 484.236 428.826 484.033 430.147C483.821 431.479 483.276 432.74 482.398 433.931C481.989 434.487 481.587 434.961 481.192 435.353C480.801 435.765 480.355 436.145 479.853 436.493L477.92 434.805C478.422 434.527 478.859 434.219 479.231 433.881C479.615 433.551 479.978 433.153 480.321 432.688C480.906 431.894 481.258 431.085 481.375 430.261C481.503 429.446 481.383 428.648 481.013 427.867C480.646 427.107 480.031 426.408 479.169 425.773C478.319 425.146 477.456 424.772 476.581 424.653C475.698 424.544 474.871 424.67 474.099 425.028C473.326 425.387 472.664 425.94 472.113 426.689C471.77 427.154 471.478 427.621 471.236 428.091C470.995 428.561 470.796 429.08 470.64 429.648L468.519 428.215C468.67 427.749 468.892 427.247 469.183 426.709C469.466 426.182 469.796 425.664 470.172 425.153Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M473.723 444.479L467.947 451.025L466.109 449.402L469.941 445.06L467.278 442.71L463.754 446.704L461.963 445.124L465.487 441.13L462.571 438.556L458.697 442.947L456.843 441.31L462.661 434.717L473.723 444.479Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M159.415 185.977L161.374 183.246L176.787 187.074L174.901 189.701L171.385 188.765L167.799 193.762L169.812 196.793L168.025 199.284L159.415 185.977ZM169.096 188.111L165.582 187.098C165.137 186.969 164.594 186.796 163.952 186.579C163.299 186.353 162.741 186.152 162.277 185.975L162.253 186.01C162.56 186.404 162.908 186.861 163.297 187.383C163.674 187.897 164.021 188.38 164.338 188.833L166.422 191.837L169.096 188.111Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M187.208 176.105C186.156 177.185 184.995 177.942 183.725 178.377C182.445 178.802 181.16 178.859 179.871 178.547C178.571 178.225 177.371 177.528 176.271 176.456C175.181 175.394 174.474 174.232 174.148 172.971C173.823 171.69 173.881 170.388 174.322 169.067C174.773 167.736 175.589 166.465 176.769 165.254C177.919 164.073 179.009 163.227 180.039 162.715L181.784 164.711C181.278 164.887 180.724 165.173 180.121 165.569C179.528 165.956 178.976 166.411 178.465 166.936C177.747 167.673 177.264 168.471 177.016 169.331C176.768 170.172 176.774 171.014 177.034 171.857C177.284 172.691 177.777 173.467 178.514 174.185C179.25 174.903 180.034 175.391 180.864 175.649C181.695 175.887 182.527 175.882 183.36 175.632C184.194 175.382 184.985 174.873 185.732 174.106C186.234 173.591 186.587 173.129 186.79 172.717L184.156 170.151L181.958 172.406L180.263 170.754L184.437 166.47L190.114 172.002C189.436 173.445 188.467 174.813 187.208 176.105Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M188.768 154.663L195.693 149.348L197.186 151.293L192.592 154.819L194.754 157.636L198.979 154.393L200.433 156.288L196.208 159.531L198.576 162.616L203.22 159.052L204.726 161.013L197.751 166.367L188.768 154.663Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M206.44 142.333L209.003 140.812L216.536 153.497L213.973 155.019L206.44 142.333Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M220.356 134.781L223.999 133.194L230.322 138.393C230.752 138.744 231.322 139.241 232.032 139.885C232.75 140.51 233.368 141.063 233.885 141.544L233.924 141.528C233.684 141.048 233.332 140.31 232.867 139.314C232.402 138.317 231.996 137.418 231.647 136.618L229.173 130.94L231.634 129.868L237.527 143.393L234.077 144.896L227.722 139.78C227.123 139.288 226.45 138.713 225.702 138.055C224.954 137.397 224.37 136.867 223.949 136.466L223.911 136.483C224.105 136.86 224.414 137.516 224.838 138.454C225.275 139.386 225.648 140.207 225.958 140.917L228.71 147.235L226.249 148.307L220.356 134.781Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M253.079 138.877C251.622 139.266 250.237 139.322 248.923 139.046C247.606 138.755 246.474 138.146 245.526 137.218C244.574 136.276 243.9 135.063 243.504 133.579C243.112 132.109 243.099 130.748 243.465 129.498C243.842 128.231 244.557 127.143 245.613 126.234C246.682 125.322 248.033 124.647 249.667 124.211C251.26 123.786 252.63 123.617 253.776 123.705L254.253 126.312C253.729 126.204 253.106 126.166 252.385 126.198C251.678 126.227 250.971 126.335 250.263 126.524C249.269 126.79 248.445 127.228 247.792 127.84C247.148 128.435 246.722 129.161 246.514 130.019C246.302 130.863 246.328 131.782 246.593 132.776C246.859 133.77 247.282 134.591 247.863 135.238C248.454 135.867 249.172 136.288 250.016 136.501C250.86 136.713 251.8 136.681 252.834 136.404C253.529 136.219 254.069 136.002 254.454 135.753L253.506 132.2L250.463 133.012L249.853 130.725L255.632 129.182L257.676 136.84C256.354 137.733 254.821 138.412 253.079 138.877Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M252.281 503.804L248.459 502.505L249.298 500.156L259.827 503.921L258.987 506.27L255.128 504.822L250.978 516.425L248.132 515.408L252.281 503.804Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M270.238 506.8L274.416 507.679C275.685 507.946 276.724 508.279 277.532 508.68C278.355 509.083 278.941 509.617 279.291 510.281C279.657 510.934 279.739 511.743 279.536 512.708C279.339 513.646 278.918 514.349 278.272 514.818C277.629 515.273 276.805 515.496 275.799 515.486L275.79 515.528C276.104 515.68 276.346 515.86 276.518 516.069C276.704 516.281 276.848 516.52 276.951 516.787C277.053 517.053 277.145 517.404 277.226 517.838L278.351 523.583L275.145 522.908L274.393 518.474C274.291 517.862 274.177 517.413 274.05 517.127C273.936 516.844 273.738 516.622 273.455 516.462C273.175 516.288 272.738 516.139 272.145 516.014L271.38 515.853L270.119 521.852L267.202 521.238L270.238 506.8ZM272.698 513.797C273.856 514.041 274.731 514.059 275.321 513.852C275.926 513.648 276.304 513.188 276.454 512.471C276.562 511.96 276.513 511.54 276.309 511.209C276.119 510.881 275.793 510.618 275.33 510.42C274.885 510.211 274.283 510.027 273.524 509.867L272.676 509.689L271.85 513.619L272.698 513.797Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M292.417 510.519L301.125 511.139L300.95 513.584L295.174 513.173L294.921 516.715L300.235 517.094L300.065 519.476L294.752 519.098L294.476 522.977L300.316 523.393L300.14 525.86L291.37 525.235L292.417 510.519Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M312.977 511.185L316.942 510.926L321.129 517.961C321.414 518.436 321.782 519.097 322.233 519.943C322.697 520.775 323.09 521.504 323.414 522.133L323.456 522.13C323.393 521.598 323.311 520.784 323.212 519.689C323.112 518.594 323.034 517.611 322.977 516.739L322.574 510.559L325.253 510.384L326.213 525.106L322.458 525.351L318.213 518.384C317.816 517.718 317.378 516.949 316.897 516.076C316.416 515.204 316.046 514.508 315.786 513.988L315.744 513.991C315.8 514.411 315.868 515.134 315.949 516.159C316.044 517.184 316.117 518.083 316.167 518.856L316.616 525.732L313.937 525.907L312.977 511.185Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M335.314 508.834L339.265 508.003C341.885 507.453 344.082 507.595 345.857 508.432C347.631 509.268 348.785 510.955 349.318 513.493C349.66 515.12 349.572 516.55 349.054 517.782C348.546 518.997 347.705 519.995 346.529 520.775C345.365 521.538 343.956 522.093 342.301 522.441L338.35 523.272L335.314 508.834ZM341.567 520.285C343.318 519.916 344.635 519.229 345.518 518.223C346.4 517.216 346.659 515.844 346.294 514.107C345.911 512.287 345.124 511.113 343.934 510.586C342.74 510.045 341.254 509.961 339.475 510.335L338.709 510.496L340.801 520.446L341.567 520.285Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M365.331 516.306C364.031 516.771 362.732 517.01 361.436 517.025L360.819 514.485C362.11 514.622 363.293 514.498 364.368 514.114C365.124 513.843 365.68 513.472 366.035 513.001C366.39 512.53 366.471 512.022 366.276 511.478C366.148 511.12 365.959 510.843 365.71 510.648C365.456 510.44 365.096 510.291 364.631 510.203C364.179 510.111 363.547 510.06 362.735 510.051C361.79 510.044 360.995 509.955 360.349 509.781C359.712 509.59 359.182 509.301 358.76 508.913C358.35 508.521 358.026 507.993 357.789 507.33C357.5 506.52 357.452 505.737 357.645 504.98C357.851 504.217 358.269 503.544 358.898 502.96C359.536 502.358 360.345 501.881 361.327 501.53C361.951 501.307 362.542 501.141 363.102 501.03C363.674 500.915 364.263 500.847 364.869 500.825L365.461 503.172C364.855 503.15 364.302 503.175 363.805 503.248C363.32 503.317 362.859 503.429 362.421 503.586C361.692 503.847 361.16 504.201 360.827 504.65C360.488 505.085 360.405 505.541 360.575 506.019C360.685 506.324 360.846 506.566 361.059 506.744C361.281 506.904 361.611 507.033 362.05 507.13C362.485 507.215 363.083 507.255 363.845 507.252C364.83 507.244 365.656 507.338 366.325 507.533C367.006 507.723 367.563 508.025 367.996 508.439C368.428 508.853 368.768 509.405 369.014 510.095C369.327 510.971 369.39 511.816 369.203 512.631C369.011 513.433 368.581 514.156 367.913 514.799C367.253 515.424 366.393 515.926 365.331 516.306Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_475_15274",
    x: 106.273,
    y: 90.4792,
    width: 225.348,
    height: 175.736,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.60847,
    dy: 9.21694
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.60847
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_475_15274"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_475_15274",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_475_15274",
    x: 85.8715,
    y: 248.594,
    width: 128.561,
    height: 256.789,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.60847,
    dy: 9.21694
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.60847
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_475_15274"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_475_15274",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_475_15274",
    x: 177.039,
    y: 461.934,
    width: 262.534,
    height: 99.4195,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.21694
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.60847
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_475_15274"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_475_15274",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_475_15274",
    x: 416.476,
    y: 268.28,
    width: 141.133,
    height: 249.147,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.60847,
    dy: 9.21694
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.60847
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_475_15274"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_475_15274",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_475_15274",
    x: 324.051,
    y: 91.3188,
    width: 221.726,
    height: 189.378,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.60847,
    dy: 9.21694
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.60847
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_475_15274"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_475_15274",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonBeats);
export default __webpack_public_path__ + "static/media/commonBeats.9f2f95ae6836721bcf48934a9844e43d.svg";
export { ForwardRef as ReactComponent };